"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgShoppingCartFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M9.02 20a2 2 0 11-4 0 2 2 0 014 0zM21.025 20a2 2 0 11-4 0 2 2 0 014 0zM18.324 12.997H7.234l-1.609-7h15.379l-2.68 7z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.004 2.996a1 1 0 011-1h1.94a1 1 0 01.976.778l.504 2.223h14.58a1 1 0 01.934 1.357l-2.68 7a1 1 0 01-.934.643H7.234a1 1 0 01-.975-.776L4.65 6.218l-.504-2.222H3.004a1 1 0 01-1-1zm4.877 4l1.149 5h9.606l1.914-5H6.881z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8.316 12.415l1.633 1.154L8.937 15h10.067a1 1 0 110 2H7.006a1 1 0 01-.817-1.577l2.127-3.008z' }))); };
exports.default = SvgShoppingCartFilled;
//# sourceMappingURL=ShoppingCartFilled.js.map